module.exports = __webpack_public_path__ + "static/img/1_3_2.64c2a8af.jpg";